import React, { Component } from "react";
import FetchCall, { partnerApi, updategallery } from './../../../../API/FetchCall';
import SimpleReactValidator from 'simple-react-validator';
import jQuery from 'jquery'; import {
  Collapse,
  CardBody,
  Card,
  CardHeader
} from 'reactstrap';

import 'react-notifications/lib/notifications.css';

import {NotificationContainer, NotificationManager} from 'react-notifications';

class Gallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_data: JSON.parse(localStorage.getItem("user_data")),
      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
      user_type: 0,
      access: [],
      photos_arr: [],
      delete_array: [],
      edit_image: '',
      url: '',
      image_count: 0,
      photos_arr_length: 0,
      showupload: false, imagename: '', newimage: '', removeindex: '',
      attachment_file: [],
      attachment_file_length: 0,
      attachment_fileName: [],
      tempBanner: '',
      active_status: 0,
      main_id: 0,
      main_access: '',
      collapse: 0,
      page_data: [],
      btnDisabled: false
    }
    this.validator = new SimpleReactValidator({
      validators: {
        checkExist: {  // name the rule
          message: 'The :attribute field is required.',
          rule: (val, params, validator) => {
            if (val == '' && this.state.edit_image == '') {
              return false;
            }
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        }
      }
    });
    this.loadFile = this.loadFile.bind(this);
    this.getgallery;
    this.getGallery();
    this.toggle = this.toggle.bind(this);
  }
  toggle(event) {
    this.setState({
      collapse: this.state.collapse === Number(event) ? -1 : Number(event)
    });
  }
  componentDidMount() {
    if (this.state.authentication == true) {
      this.setState({
        access: this.state.user_data.current_category.split(','),
        user_type: this.state.user_data.user_type
        // access: [1]
      });
    }
  }
  getGallery = () => {
    const { user_type, login_id, set_id } = this.state.user_data;
    let req = JSON.stringify({
      user_type: user_type,
      login_id: login_id,
      sid: set_id,
      url: 'getGalleryNew'
    });
    partnerApi(req).then((response) => {

      if (response.status === 1) {
        let data = response.result;
        let imagecnt = data.max_gallery;
        if (data.plan_id == 0) {
          imagecnt = user_type == 1 ? 8 : 7;
        }
        this.setState({
          page_data: data.master_data,
          active_status: response.result.active_status,
          image_count: imagecnt
        });
      }
    })
  }
  getgallery = () => {
    const { user_type, login_id, is_completd, current_plan, current_category, uid, branch_id } = this.state.user_data;
    let req = JSON.stringify({
      user_type: user_type,
      login_id: login_id,
      branch_id: branch_id,
      uid: uid,
      is_completd: is_completd,
      category: current_category,
      url: 'getContactData'
    });
    partnerApi(req).then((response) => {

      if (response.status === 1) {
        let data = response.result;
        let imagecnt = data.image_count;
        if (current_plan == 0) {
          imagecnt = user_type == 1 ? 8 : 7;
        }
        this.setState({
          attachment_file: data.photo_arr,
          active_status: data.active_status,
          main_id: data.main_id ? data.main_id : 0,
          main_access: data.main_access ? data.main_access : 0,
          url: data.url,
          image_count: imagecnt,
          edit_image: data.banner_image_up,
        });
      }
      console.log(this.state.photos_arr);
    })
  }
  loadFile(e, index,image_count) {
    var files = e.target.files
    let page_data = this.state.page_data;
    this.setState({ attachment_file_length: files.length })
    if (files.length > 0) {
      let toastr = window.toastr.warning;
      let errormsg = 'To upload more than ' + image_count + ' Image, Upgrade your plan';
      if (files.length <= image_count) {
        jQuery('.upload-space').addClass('hide')
        jQuery('.upload-thumb').removeClass('hide')
        var fileArra = page_data[index].attachment_file
        let total = fileArra.length + files.length;
        if (total <= image_count) {
          let err = '';
          for (var i = 0; i < files.length; i++) {
            if (e.target.files[i].size <= 1000000)
              fileArra.push(e.target.files[i])
            else
              err = 'Image should be less than 1 MB';
          }
          page_data[index].attachment_file = fileArra
          this.setState({
            page_data
          });
          if (err)
            NotificationManager.error(err);
        } else {
          NotificationManager.error(errormsg);
          
        }
      } else {
        NotificationManager.error(errormsg);
         
      }

    }
  }
  removeImage = (e, index) => {
    let page_data = this.state.page_data;
    console.log('delete_array', page_data[index], e)
    var delete_array = page_data[index].delete_array ? page_data[index].delete_array : [];
    delete_array.push(e);
    console.log('delete_array after', page_data[index])
    const updated = page_data[index].attachment_file.filter(item => item.name != e);
    page_data[index].delete_array = delete_array;
    page_data[index].attachment_file = updated;
    console.log('delete_array main', page_data[index])
    this.setState({
      page_data
    })
  }
  handleFile = (e, index) => {
    const propName = e.target.name;
    const files = e.target.files[0];
    let page_data = this.state.page_data;
    page_data[index]['newimage'] = files;
    this.setState({ page_data });
    const reader = new FileReader();
    let img = '';
    let THIS = this;
    reader.addEventListener("load", function () {
      // convert image file to base64 string
      img = reader.result;
      page_data[index]['tempBanner'] = reader.result;
      THIS.setState({
        page_data
      });
    }, false);

    if (files) {
      reader.readAsDataURL(files);
      console.log('img1', img);
    } else {
      page_data[index]['tempBanner'] = '';
      THIS.setState({
        page_data
      });
    }


  };
  render() {
    this.validator.purgeFields();
    const { access, user_type, collapse, page_data } = this.state;
    console.log('page_data', page_data)
    return (
      <React.Fragment>
         <div class="category_block">

        <div class="titleline">
        <h4>Media</h4>
        <span>Manage all of your images and videos of your institutions</span>
        </div>

        <div>
        <form onSubmit={(e) => this.submitForm(e)}>
                        <div class="box-shadow-custom">
                          <div class="row">
                            <div className="form-group col-md-6 mar-btm" style={{ minHeight: 'unset' }}>
                              <label>
                                Logo/Banner Image <span className="astrick">* (Webp, JPG, PNG in 300X300 pixels) (size less than or equal to 512KB)</span>
                              </label>
                              <input
                                type="file"
                                name="newimage"
                                accept="image/x-png,image/gif,image/jpeg"
                                onChange={(e) => this.handleFile(e)}
                                className="form-control mar-btm"
                              />
                            </div>
                             
                            <div className="upload-wizard-wrap col-md-12">
                              <div>
                                <div class="col-md-12 float-left mt-4 pad-no">
                                  <label>
                                    Gallery Images <span className="astrick">* (Webp, JPG, PNG in 980X360 pixels) ((size less than or equal to 1MB)</span>
                                  </label>
                                </div>

                                <div class="col-md-12 float-left mt-4 pad-no">

                                  <div class="col-md-12 margin-bottom-mobile-account float-left image-upload">
                                    <div className='upload-wizard'>
                                      <div className='upload-thumb'>
                                        <ul className='list-inline'>
                                          
                                            <li className='addMore'>
                                              <input
                                                type='file'
                                                name='imgInp[]'
                                                id='imgInp2'
                                                className='add_img'

                                                onChange={(e) => this.loadFile(e)}
                                                accept="image/x-png,image/gif,image/jpeg"
                                              />
                                              <a href='javascript:;' className='add-more'>
                                                <div>
                                                  <img src={'../assets/images/upload-icon.svg'} alt='icon' />
                                                  Add more
                                                </div>
                                              </a>
                                            </li>
                                        

                                        </ul>
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                            <div class="videos">
                            <div class="form-group col-md-4">
                                <label> Video (.mp4) (size less than or equal to 5MB) </label>
                              </div>
                              <div class="form-group col-md-6">
                                <input
                                  type="file"
                                  name="video_new"
                                  size="10024"
                                  onChange={(e) => this.handleFile(e)}
                                  className="form-control mar-btm"
                                  accept="video/mp4"
                                />
                               
                              </div>
                              <div class="col-md-12">
                              <span className="astrick"><li>inappropriate videos will be deleted</li></span>
                                <span className="astrick"><li>Uploading video should be within 10MB</li></span>
                                <span className="astrick"><li>Uploading video should be .mp4 format only and not more than 2 minutes.</li></span>
                                <span className="astrick"><li>Video will be displayed on the website after admin's approval.</li></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="notesgal">You can select/deselect to copy the same set of files to below listing</div>
                        <div class="chooselisting">

                        {page_data.map((item, index) => {

                            return (

                                <div class="optionitem"><input type="checkbox" class="" name="chosenlisting[]" value={item.id} />&nbsp;<b>{item.category_name} </b> - {item.organisation_name}</div>
                            )
                            
                            })
                        }

                        </div>

                        <div class="col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm">
                            <button type='submit' id="btnSubmit"
                            className="btn btn-primary btn-sm" disabled={this.state.btnDisabled}>
                            Submit and Proceed next
                            </button>
                        </div>
                      </form>
        </div>

        
        </div>
        <NotificationContainer/>
      </React.Fragment >
    );
  }
  submitForm = (e) => {
    e.preventDefault();
    this.setState({
      btnDisabled: true
    })
    const { user_type, login_id } = this.state.user_data;
    let page_data = this.state.page_data;
    let request = {
      user_type: user_type,
      login_id: login_id,
      active_status: this.state.active_status,
      data: JSON.stringify(page_data),
      delete_array: page_data.delete_array,
      images: page_data.newimage,
      photos: page_data.attachment_file ? page_data.attachment_file : []
    };

    updategallery(request).then(res => {
      let toastr = '';
      this.setState({
        btnDisabled: false
      })
      if (res.status === 1) {
       
        NotificationManager.success(res.message);
        /*
        setTimeout(function () {
          window.location.reload();
        }, 1000);
        */
      } else {
        
        NotificationManager.error(res.message);
        
      }
    });
  };
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/bewise/partners/other_info/Media.jsx